export const mappingCompanySlugToName = (slug: string) => {
  const arr = slug?.split('-').map((item) => item.charAt(0).toUpperCase() + item.slice(1));
  return arr.join(' ');
};
export const mappingCompanySlugToCode = (slug: string) => {
  switch (slug) {
    case 'vietnam-airlines':
      return 'VN';
    case 'vietjet-air':
      return 'VJ';
    case 'bamboo-airways':
      return 'QH';
    case 'vietravel-airlines':
      return 'VU';
    case 'pacific-airlines':
      return 'BL';
    default:
      return 'VN';
  }
};
